import { DeviceHelper, Device } from '../Core/DeviceHelper';

const device = DeviceHelper.GetDevice();


const defaultOptions = {
    mobile: {
        rows: 4,
        posters: 3
    },
    tablet: {
        rows: 2,
        posters: 5
    },
    desktop: {
        rows: 2,
        posters: 5
    }
};
let maxItems = 0;

const calculateMaxItems = (rows, posters, append) => {
    if (append)
        maxItems += rows * posters;
    else
        maxItems = rows * posters;
};



export default class ShowMore {
    constructor(source, options) {
        this.source = source;        
        this.options = options || defaultOptions;

        // init max items
        const { rows, posters } = this.getConfig();
        calculateMaxItems(rows, posters);
        this.apply();
    }


    getConfig() {
        return this.options[device];
    }


    showMore() {
        if (maxItems > this.source.length) return;
        const { rows, posters } = this.getConfig();

        calculateMaxItems(rows, posters, true);
        this.apply(false);
    }

    needMore() {
        return maxItems < this.source.length;
    }

    reset() {
        const { rows, posters } = this.getConfig();
        calculateMaxItems(rows, posters);
        this.apply();
    }

    apply(hide = true) {
        if (hide) this.source.hide();
        const items = this.source.slice(0, maxItems);
        items.fadeIn();
    }
}





// WEBPACK FOOTER //
// ./Statics/scripts/Modules/ShowMore.js